import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type BeneficiaryAddedToastProps = {
  toastId: string | number;
};

export const BeneficiaryAddedToast: FC<BeneficiaryAddedToastProps> = ({toastId}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('view.beneficiaries.addedToast.title')}
      description={t('view.beneficiaries.addedToast.description')}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('view.beneficiaries.toastClose')}
    />
  );
};

export function showBeneficiaryAddedToast(): void {
  toast.custom(id => <BeneficiaryAddedToast toastId={id} />, {duration: 10_000});
}
